import Mustache from 'mustache';

const folderTitleDivs = document.querySelectorAll('.file-list-fetch__button');
const fetchResultsFolders = document.querySelectorAll('div[id^="fetch-results__"]');
const searchInput = document.querySelector('.js-material-bank__search');

/**
 * fetch Studio folder's data, add it to search
 *
 */
export default function fetchFolderData() {

  for (let i = 0; i < fetchResultsFolders.length; i++) {
    fetchData(fetchResultsFolders[i], i);
    i === 0 && folderTitleDivs[0].classList.add('open');
  }

  searchInput.addEventListener('keyup', searchItems);
}

/**
 * Use Mustache template to render the fetched files
 * @param {object} items fetched inside fetchData()
 * @param {HTMLElement} container html element (folder) where the data is rendered
 */
function renderItems(items, container) {
  const template = document.getElementById('js-file-list-fetch-template').innerHTML;
  const rendered = Mustache.render(template, items);
  container.innerHTML = rendered;
}

/**
 * Search files in all folders
 * @param {Event} e event triggered with keyup inside the search form
 */
function searchItems(e) {
  const searchReg = new RegExp(e.target.value.toUpperCase());

  for (let folderIndex = 0; folderIndex < fetchResultsFolders.length; folderIndex++) {
    const items = fetchResultsFolders[folderIndex].children;

    let searchResultsCount = 0;

    for (let i = 0; i < items.length; i++) {
      const itemTitle = items[i].querySelector('p') ? items[i].querySelector('p').innerText.toUpperCase() : null;

      !searchReg.test(itemTitle) ?
        items[i].classList.add('hidden') :
        (items[i].classList.remove('hidden'), searchResultsCount++);
    }
    folderTitleDivs[folderIndex].classList.add('open');
    searchResultsCount > 0 && fetchResultsFolders[folderIndex].classList.remove('hidden');
  }
}

/**
 *  Fetch data for a specific folder
 * @param {object} folder fetched inside fetchData()
 * @param {HTMLElement} folder html element (folder), the id of which is used to fetch the data
 */

function fetchData(folder, index) {

  const folderId = folder.id.substring(15)
  folder.classList.add('spinner', 'spinner--black');

  const companyUuid = document.getElementById('js-material-bank--fetch').getAttribute('data-company');
  const showItemsButton = document.getElementById(folderId);

  fetch('/stage-ajax/file-list-fetch/' + folderId + '/' + companyUuid + '/')
    .then(response => response.json())
    .then(data => {
      folder.classList.remove('spinner', 'spinner--black');
      renderItems(data, folder);
      index !== 0 && folder.classList.toggle('hidden');

      showItemsButton.addEventListener('click', () => {
        showItemsButton.classList.toggle('open');
        folder.classList.toggle('hidden');
      });
    })
    .catch(error => {
      folder.innerHTML = 'Something went wrong.';
      console.error(error);
    })
}
